<template>
  <!-- 已选 -->
  <!-- 凑单页、分类列表页公用 -->
  <!-- 从优选抽出的频道“分类列表页”，一级分类单独写 -->
  <div
    class="SelectBar"
    @click.stop
  >
    <div
      v-if="(chooseCategory && chooseCategory.name || activeBrand) && showSelected"
      class="selected row"
    >
      <span>{{ TLang('已选','my') }}</span>
      <ul>
        <li v-if="chooseCategory && chooseCategory.name">
          <span>{{ TLang('分类','my') }}</span>
          <span>{{ chooseCategory.father_name }} </span>
          <span v-if="chooseCategory.father_name && chooseCategory.id !== chooseCategory.father_id"> - </span>
          <span v-if="chooseCategory.id !== chooseCategory.father_id">{{ chooseCategory.name == '全部'? currentFirstName : chooseCategory.name }}</span>
          <i
            v-if="channelId !== '3'"
            class="icon iconfont"
            @click="chooseAllGoods"
          >&#xe65d;</i>
        </li>
        <li v-if="activeBrand">
          {{ TLang('品牌','my') + '：' + activeBrand }}
          <i
            class="icon iconfont"
            @click="delBrand"
          >&#xe65d;</i>
        </li>
      </ul>
    </div>
    <div class="line"></div>
    <!-- 一级分类 -->
    <div
      v-if="channelId === '2' || channelId === '17' || channelId == healthChannelId"
      :class="'life-category'"
    >
      <div
        v-if="catList.length"
        class="category row"
      >
        <span>{{ TLang('分类','my') }}</span>
        <ul>
          <li
            :class="{'all-goods': ID_TYPE === 'ALL'}"
            @click="chooseAllGoods(channelId === '2' ? 1 : '')"
            @mousedown="activeHover = {}"
          >
            {{ TLang('全部','my') }}
          </li>
          <li
            v-for="(first,index) in catList"
            :key="index"
            :class="[
              ID_TYPE === 'ONE' && first.id === chooseCategory.id ? 'active' : '',
              ID_TYPE === 'TWO' && first.id === chooseCategory.father_id ? 'active' : '',
              first.id === activeHover.id && 'active'
            ]"
            @mousedown="enterOneCategory(first)"
          >
            <span>{{ first.name }}</span>
            <span
              v-show="first.subCategoryList && first.subCategoryList.length > 1"
              class="hasMore"
            ></span>
          </li>
        </ul>
      </div>
      <!-- 二级分类 -->
      <div
        v-if="activeHover.name"
        class="sub-list-wrap"
      >
        <ul>
          <li
            v-for="sub in activeHover.current_list || activeHover.subCategoryList"
            :key="sub.id"
            :class="[
              ID_TYPE === 'ONE' && sub.id === chooseCategory.id ? 'active' : '',
              ID_TYPE === 'TWO' && sub.id === chooseCategory.id ? 'active' : '',
            ]"
            @click="clickTowCategory(sub)"
          >
            {{ sub.name }}
          </li>
        </ul>
      </div>
    </div>
    <!-- 生日汇的一级分类 -->
    <div
      v-else-if="channelId === '3'"
      class="birthday-category category row"
    >
      <span>{{ TLang('分类','my') }}</span>
      <div class="birthday-wrap">
        <div
          v-for="birthday in catList"
          :key="birthday.id"
          :class="['birthday-item', goodsType == birthday.goodsType && 'active']"
          @click="clickBirthdayItem(birthday.goodsType,birthday)"
        >
          {{ birthday.name }}
        </div>
      </div>
    </div>
    <!-- 以下用于分类列表页：优选中抽出的二级分类展示成一级分类（如图书：前沿新知等） -->
    <div
      v-else-if="channelId === '998' || channelId === '18'"
      class="book-category category row"
    >
      <span>{{ TLang('分类','my') }}</span>
      <div class="book-wrap">
        <div
          :class="['all-book', ID_TYPE === 'ALL' && 'all-goods']"
          @click="chooseAllGoods(1)"
          @mousedown="activeHover = {}"
        >
          {{ TLang('全部','my') }}
        </div>
        <div
          v-for="book in catList"
          :key="book.id"
          :class="['book-item', ID_TYPE === 'ONE' && bookId == book.id && 'active']"
          @click="clickBookItem(book.id,book)"
        >
          {{ book.name }}
        </div>
      </div>
    </div>
    <!-- 以上 -->
    <!-- 品牌 -->
    <div
      v-if="brandList && brandList.length && hideBrand"
      class="brands row"
    >
      <span>{{ TLang('品牌','my') }}</span>
      <ul
        :style="{height: showMoreBrand ? 'auto' : '40px'}"
        :class="{showMoreBrand}"
      >
        <li
          :class="{active: !activeBrand}"
          @click="delBrand"
        >
          {{ TLang('全部','my') }}
        </li>
        <li
          v-for="(brand,index) in brandList"
          :key="index"
          :class="[activeBrand === brand.text && 'active']"
          :style="{display: brand.name.trim() ? 'block': 'none'}"
          @click="onBrandsChange(brand)"
        >
          {{ brand.text }}
        </li>
      </ul>
      <div
        v-if="brandList.length >= 12"
        class="hideBottom"
      >
        <span
          @click="showMoreBrand = !showMoreBrand"
        >{{ showMoreBrand ? TLang('收起','my') : TLang('展开','my') }}</span>
        <i :class="showMoreBrand && 'down'"></i>
      </div>
    </div>
  </div>
</template>

<script>
// 所有入口的校验
import { getQueryString,gioClickHandle } from '@utils';
import { healthChannelId,channelNames } from '@utils/config';
export default {
  props: {
    catList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    channelCode:{
      type: Number,
      default:2,
    }, // 用于凑单页区分图书
    onBrandChange: Function,
    onCateChange: Function,
    brandList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    hideBrand: Boolean,
    chooseAll: Function,
    selectType:String, //list分类列表 add凑单
    changeBirthdayFirstType: Function,
    showSelected: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeHover: {},
      chooseCategory: {},
      activeBrand: null, //选中的品牌
      channelId: getQueryString('channelId') || '2', //分类页区分图书
      goodsType: getQueryString('goodsType') || '0',
      bookId: getQueryString('categoryId') || '0',
      showMoreBrand: false, // 品牌展开
      ID_TYPE: 'ONE', // ONE 一级分类id TWO 二级分类id ALL无id 全部
      healthChannelId: healthChannelId,
      currentFirstName: '', //当前选中的一级分类的name
    };
  },
  mounted() {
    if(getQueryString('mId')){
      this.ID_TYPE = 'ALL';
    };
    this.init();
    let filterBrand = this.brandList.filter(brand => brand.name === getQueryString('bn') );
    if(filterBrand.length){
      this.activeBrand = getQueryString('bn');
    };
  },
  methods: {
    init() {
      // 根据url 挑选出已选
      if(getQueryString('categoryId')){
        this.catList.filter(item => {
          if(item.id == getQueryString('categoryId')){
            this.chooseCategory = item;
            this.ID_TYPE = 'ONE';
          }else if(item.subCategoryList && item.subCategoryList.length > 0){
            item.subCategoryList.filter(sub => {
              if(sub.id == getQueryString('categoryId')){
                this.chooseCategory = sub;
                this.ID_TYPE = 'TWO';
              }
            });
          }
        });
      }else {
        this.chooseCategory = {};
        this.ID_TYPE = 'ALL';
      }
      this.activeHover = this.chooseCategory;


      // 生日汇默认选中匹配的goodsType
      if(this.channelId === '3'){
        this.chooseCategory = this.catList.filter(item => item.goodsType == getQueryString('goodsType'))[0];
        this.changeBirthdayFirstType(this.chooseCategory);
      }
    },
    senGio(item,type){
      const params = {
        df_channle:channelNames['channel'+this.channelId],
        df_pagename:'分类商品列表页',
        df_modulename:'分类筛选',
      };
      if(type === 1){
        params.df_elementname = '一级分类';
        params.df_firstCategory = item.name;
        params.df_firstCategoryId = ''+item.id;
      }
      if(type === 2){
        params.df_elementname = '二级分类';
        params.df_secondCategory = item.name;
      }
      if(params.df_channle){
        gioClickHandle('DF_elementClick',params,'channelGio');
      }
    },
    sendFilterGio(modulename,elementname){
      const params = {
        df_channle:channelNames['channel'+this.channelId],
        df_pagename:'分类商品列表页',
        df_modulename:modulename,
        df_elementname:elementname,
      };
      if(params.df_channle){
        gioClickHandle('DF_elementClick',params,'channelGio');
      }
    },
    // 点击一级分类
    enterOneCategory(list) {
      // console.log(list.subCategoryList);
      this.currentFirstName = list.name;
      this.senGio(list,1);
      if(list.subCategoryList && list.subCategoryList.length > 0){
        // 有二级分类
        this.activeHover = list;

        // 调一级分类结果
        this.clickTowCategory(list);
      } else {
        // 没有二级分类
        if(this.selectType === 'list'){
          this.$router.push({
            path: '/product/list',
            query: {
              ...this.$route.query,
              categoryId: list.id,
              bn: null,
            // keyword: null,
            },
          });
          this.onCateChange(list);
        } else if(this.selectType === 'add'){
          this.$router.push({
            path: '/add/list',
            query: {
              ...this.$route.query,
              // categoryId: list.id,
              // bn: null,
              // keyword: null,
            },
          });
          this.onCateChange(list,this.currentFirstName);
        }
        this.init();
      }
    },

    // 切换分类
    clickTowCategory(sub){
      this.senGio(sub,2);
      if(sub.id !== this.chooseCategory.id){
        this.chooseCategory = sub;
        this.activeBrand = null;
        this.ID_TYPE = 'TWO';
        if(this.selectType === 'list'){
          this.$router.push({
            path: '/product/list',
            query: {
              ...this.$route.query,
              categoryId: sub.id,
              bn: null,
            // keyword: null,
            },
          });
          this.onCateChange(sub);
        }else if(this.selectType === 'add'){
          this.$router.push({
            path: '/add/list',
            query: {
              ...this.$route.query,
              // categoryId: sub.id,
              // bn: null,
              // keyword: null,
            },
          });
          this.onCateChange(sub,this.currentFirstName);
        }
      }
    },
    // 点击全部
    chooseAllGoods(type){
      this.ID_TYPE = 'ALL';
      this.chooseCategory = {};
      this.activeHover = {};
      this.activeBrand = null;
      this.currentFirstName = '';
      this.chooseAll();
      if(type){
        this.senGio({name:'全部',id:''},type);
      }
    },

    // 切换品牌 清除了搜索条件
    onBrandsChange(brand) {
      this.sendFilterGio('品牌筛选',brand.name);
      this.$router.push({
        path: '/product/list',
        query: {
          ...this.$route.query,
          bn: brand.name,
          // keyword: null,
        },
      });
      this.activeBrand = brand.text;
      this.onBrandChange(brand.name);

    },
    // 点击生日汇下面的一级分类 单选
    clickBirthdayItem(goodsType,birthday){
      this.changeBirthdayFirstType(birthday);
      this.$router.push({
        path: '/product/list',
        query: {
          ...this.$route.query,
          goodsType,
          bn: null,
        },
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
    // 点击图书下面的一级分类 单选
    clickBookItem(id,item){
      this.senGio(item,2);
      if(id){
        // this.$router.push({
        //   path: '/product/list',
        //   query: {
        //     ...this.$route.query,
        //     categoryId: id,
        //     channelId: '998',
        //     bn: null,
        //   },
        // });
        window.open(`/book/list?categoryId=${id}&channelId=998`,this.isFeishuOrDingding ? '_self' : '_blank');
        // window.location.href = `/book/list?categoryId=${id}&channelId=998`;
      }else{
        // this.$router.push({
        //   path: '/product/list',
        //   query: {
        //     channelId: '998',
        //     bn: null,
        //   },
        // });
        window.open(`/book/list?channelId=998`,this.isFeishuOrDingding ? '_self' : '_blank');
        // window.location.href = `/book/list?channelId=998`;
      }

      setTimeout(() => {
        window.location.reload();
      }, 300);
    },
    // 清除品牌
    delBrand(){
      this.activeBrand = null;
      this.onBrandChange(null);
      this.$router.push({
        path: '/product/list',
        query: {
          ...this.$route.query,
          bn: null,
          // keyword: null,
        },
      });
    },
  },
};
</script>

<style lang="less">
.SelectBar {
  padding: 12px 0px;
  border: 1px solid rgba(229, 229, 229, 1);
  width: 100%;
  box-sizing: border-box;
  padding-top: 0;
  .row {
    display: flex;
    align-items: center;
    padding: 0 24px;
    span {
      font-size: 14px;
      color: #666;
      line-height: 26px;
      white-space: nowrap;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: 10px;
      li {
        // span{
          color: #666;
        // }
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .selected {
    margin-bottom: 2px;
    ul {
      padding-top: 10px;
      li {
        border: 1px solid rgba(229, 229, 229, 1);
        padding: 0 5px;
        line-height: 26px;
        margin-right: 10px;
        margin-bottom: 10px;
        &:hover{
          border-color: #3FA6FF;
          border-color: var(--df-primary-color, #3FA6FF);
          i{
            color:#3FA6FF;
            color: var(--df-primary-color, #3FA6FF);
          }
        }
        i {
          line-height: 11px;
        }
      }
    }
  }
  .line{
    margin-bottom: 10px;
  }
  .category {
    // margin-bottom: 10px;
    position: relative;
    padding-right: 0;
    align-items: baseline;
    ul {
      flex-wrap: wrap;
      overflow: hidden;
      align-items: center;
      li {
        // margin-right: 18px;
        display: flex;
        align-items: center;
        line-height: 40px;
        padding-left: 12px;
        padding-right: 18px;
        height: 40px;
        cursor: pointer;
        span{
          color: #333;
        }
        .hasMore {
          display: inline-block;
          border: 5px solid transparent;
          border-top: 5px solid #3FA6FF;
          border-top: 5px solid var(--df-primary-color, #3FA6FF);
          width: 0;
          height: 0;
          transform: translate(5px, 3px);
          border-top-color: #999;
          // transition: all 0.5s ease;
          transform-style: preserve-3d;
          -webkit-perspective: 1000;
          -moz-perspective: 1000;
          -ms-perspective: 1000;
          perspective: 1000;
        }
        &:hover{
          span{
            color:#3FA6FF;
            color:var(--df-primary-color, #3FA6FF);
          }
          .hasMore {
            border-top-color: #3FA6FF;
            border-top-color: var(--df-primary-color, #3FA6FF);
            // transform: rotate(180deg) translate(-5px, 2px);
          }
        }
      }
      li.all-goods{
        padding: 0 8px;
        width:44px;
        height:24px;
        background:#3FA6FF;
        background: var(--df-primary-color, #3FA6FF);
        border-radius:2px;
        box-sizing: border-box;
        color: #fff;
        font-size:14px;
        margin-right: 10px;
        cursor: pointer;
      }
      .activeHover {
        span {
          color:#3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
        }
        .hasMore {
          border-top-color: #3FA6FF;
          border-top-color: var(--df-primary-color, #3FA6FF);
          transform-origin: center;
          // transform: rotateX(180deg) translate(5px, 3px);
        }
      }
      li.active {
        background:rgba(63,166,256,0.1);
        background: var(--df-primary-color-opacity);
        span{
          color:#3FA6FF;
          color:var(--df-primary-color, #3FA6FF);
        }
        .hasMore {
          border-top-color: #3FA6FF;
          border-top-color: var(--df-primary-color, #3FA6FF);
          transform: rotate(180deg) translate(-5px, 2px);
        }
      }
    }
  }
  .birthday-category{
    .birthday-wrap{
      margin-left: 10px;
      //display: flex;
      display: block;
      .birthday-item{
        font-size:14px;

        color:rgba(51,51,51,1);
        margin-right: 20px;
        padding: 0 8px;
        //line-height: 24px;
        line-height:1.5;
        display: inline-block;
        &:hover{
          cursor: pointer;
        }
      }
      .birthday-item.active{
        background:#3FA6FF;
        background:var(--df-primary-color, #3FA6FF);
        border-radius:2px;
        color: #fff;
      }
    }
  }
  .book-category{
    .book-wrap{
      margin-left: 14px;
      display: flex;
      .all-book{
        display: flex;
        align-items: center;
        line-height: 28px;
        padding: 0 8px;
        height: 28px;
        margin-right: 10px;
        cursor: pointer;
      }
      .all-goods{
        padding: 0 8px;
        width:44px;
        height:28px;
        background:#3FA6FF;
        background:var(--df-primary-color, #3FA6FF);
        border-radius:2px;
        box-sizing: border-box;
        color: #fff;
        font-size:14px;
        margin-right: 10px;
        cursor: pointer;
      }
      .book-item{
        font-size:14px;

        color:rgba(51,51,51,1);
        margin-right: 10px;
        padding: 0 8px;
        line-height: 28px;
        &:hover{
          cursor: pointer;
        }
      }
      .book-item.active{
        band:#3FA6FF;
        background:var(--df-primary-color, #3FA6FF);
        border-radius:2px;
        color: #fff;
      }
    }
    .category{
      ul{

        li{
          font-size:14px;

          color:rgba(51,51,51,1);
          margin-right: 10px;
          padding: 0 8px;
          line-height: 28px;
          height: 28px;
          &:hover{
            cursor: pointer;
          }
        }
        .all-goods{
          padding: 0 8px;
          width:44px;
          height:28px;
          band:#3FA6FF;
          background:var(--df-primary-color, #3FA6FF);
          border-radius:2px;
          box-sizing: border-box;
          color: #fff;
          font-size:14px;
          margin-right: 10px;
          cursor: pointer;
        }
        li.active{
          background:#3FA6FF;
          background:var(--df-primary-color, #3FA6FF);
          border-radius:2px;
          color: #fff;
          span{
            color: #fff;
          }
        }
      }
    }
  }
  .sub-list-wrap{
    padding: 0 24px;
    ul{
      display: flex;
      flex-wrap: wrap;
      padding: 5px 56px 5px;
      background:rgba(63,166,255,0.1);
      background:var(--df-primary-color-opacity);
      align-items: center;
      li{
        margin-right: 18px;
        font-size:14px;

        color:rgba(17,17,17,1);
        line-height: 24px;
        padding: 0 8px;
        margin-bottom: 4px;
        margin-top: 4px;
        &:hover{
          cursor: pointer;
          padding: 0 8px;
          background:#3FA6FF;
          background:var(--df-primary-color, #3FA6FF);
          border-radius:2px;
          color: #fff;
          font-size:14px;
          line-height: 24px;
        }
      }
      li.active{
        height:24px;
        background:#3FA6FF;
        background:var(--df-primary-color, #3FA6FF);
        border-radius:2px;
        color: #fff;
        font-size:14px;
        line-height: 24px;
      }
    }
  }
  .brands {
    align-items: baseline;
    transition: all 1s ease-in;
    position: relative;
    margin-top: 15px;

    ul {
      align-items: center;
      flex-wrap: wrap;
      height: 40px;
      overflow: hidden;
      line-height: 44px;
      transition: all 1s ease-in;
      width: 1050px;
      margin-left: 14px;
      li {
        font-size: 14px;
        color: #333;
        margin-right: 10px;
        margin-bottom: 15px;
        padding: 0 8px;
        // &:hover{
        //   color: #3d96e2;
        // }
        line-height: 24px;
      }

      .active {
        color: #fff;
        // height:24px;
        background:#3FA6FF;
        background:var(--df-primary-color, #3FA6FF);
        border-radius:2px;
        line-height: 24px;
      }
    }
    div.hideBottom{
      position: absolute;
      right: 20px;
      top: 0;
      span{
        color: #222;

      }
      i{
        position: relative;
        top: 1px;
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        line-height: 0;
        font-size: 0;
        border-width: 5px;
        border-style: solid;
        border-color: #333 transparent transparent;
        // -webkit-transition: all 0.3s ease-in-out;
        // transition: all 0.3s ease-in-out;
      }
      i.down{
        transform: rotate(180deg) translateY(50%);
        transition: none;

      }
      &:hover{
        cursor: pointer;
        span{
          color: #3FA6FF;
          color: var(--df-primary-color, #3FA6FF);
        }
        i{
          border-color: #3FA6FF transparent transparent;
          border-color: var(--df-primary-color, #3FA6FF) transparent transparent;
        }
      }
    }
    ul.showMoreBrand{
      max-height: 100px;
      overflow-y: scroll;
      scrollbar-color: #ededed transparent;
      scrollbar-track-color: #ccc;
      -ms-scrollbar-track-color: transparent;
      scrollbar-width: 3px;
      -ms-scrollbar-width: 3px;
    }
  }
}
</style>
